<style lang="scss" scoped>
.confirm-content {
    font-size: 16px;
    padding: 20px 0;
    text-align: center;
}
</style>
<template>
    <div class="clearfix" style="position: relative">
        <Form class="clearfix" :labelWidth="80" :model="formData" ref="myForm">
            <!-- 其他表单 -->
            <Col offset="2" span="18" v-if="type !== 4 && type !==6">
                <div v-if="showRemark">
                    <FormItem label="备注" prop="remark" :rules="required">
                        <Input
                            v-model="formData.remark"
                            type="textarea"
                        ></Input>
                    </FormItem>
                </div>
                <div class="confirm-content" v-else>确定操作？</div>
            </Col>
            <!-- 审核时 -->
            <div v-else>
                <Col offset="2" span="18">
                    <FormItem label="" prop="pass" :rules="required">
                        <span
                            style="
                                position: relative;
                                top: 6px;
                                left: 5px;
                                color: red;
                                font-size: 16px;
                            "
                            >*</span
                        >
                        <RadioGroup v-model="formData.pass">
                            <Radio :label="true">审核通过</Radio>
                            <Radio :label="false">审核拒回</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col offset="2" span="18">
                    <FormItem label="备注">
                        <Input
                            v-model="formData.remark"
                            type="textarea"
                        ></Input>
                    </FormItem>
                </Col>
            </div>
        </Form>
        <div class="pull-right padding-bottom-15 button-container">
            <Button type="primary" @click="submit">提交</Button>
            <Button class="margin-left-15" type="default" @click="cancel"
                >取消</Button
            >
        </div>
        <Spin v-if="loading" size="large" fix></Spin>
    </div>
</template>

<script>
import {
    HttpDestoryPlanCommit,
    HttpDestoryPlanSubmit,
    HttpDestoryPlanCancelCommit,
    HttpDestoryPlanCancel,
    HttpDestoryPlanComplete,
    HttpDestoryOrderConfirm,
    HttpDestoryOrderCancel,
    HttpDestoryPlanBatchAudit
} from "@/service/destory";
export default {
    props: ["type","ids", "isOrder", "id", "success", "otherParams"],
    data() {
        return {
            loading: false,
            required: {
                required: true,
                message: "请填写必填项",
            },
            showRemark: true,
            formData: {
                pass: true
            },
        };
    },
    created() {
        console.log(this.id, this.otherParams);
        if (this.otherParams.noCommit) this.showRemark = false;
        if (this.otherParams.noRequired) this.required.required = false;
    },
    methods: {
        /**
         * 提交
         */
        async submit() {
            let flag = true;
            await this.$refs.myForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            let reqData = {
                id: this.id,
                ids:this.ids,
                ...this.formData,
            };
            let httpSubmit;
            // 销毁单
            if (this.isOrder == 1) {
                switch (this.type) {
                    // 确认
                    case 5:
                        {
                            httpSubmit = HttpDestoryOrderConfirm(reqData);
                        }
                        break;
                    // 取消
                    case 10:
                        {
                            httpSubmit = HttpDestoryOrderCancel(reqData);
                        }
                        break;
                }
            }
            // 销毁计划单
            else {
                switch (this.type) {
                    // 提交
                    case 2:
                        {
                            httpSubmit = HttpDestoryPlanSubmit(reqData);
                        }
                        break;
                    // 撤销审核
                    case 3:
                        {
                            httpSubmit = HttpDestoryPlanCancelCommit(reqData);
                        }
                        break;
                    // 审核
                    case 4:
                        {
                            httpSubmit = HttpDestoryPlanCommit(reqData);
                        }
                        break;
                    // 完成
                    case 5:
                        {
                            httpSubmit = HttpDestoryPlanComplete(reqData);
                        }
                        break;
                    //批量审核
                    case 6:
                        {
                            httpSubmit = HttpDestoryPlanBatchAudit(reqData);
                        }
                        break;
                    // 取消
                    case 10:
                        {
                            httpSubmit = HttpDestoryPlanCancel(reqData);
                        }
                        break;
                }
            }
            httpSubmit
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$emit("on-success");
                        this.$emit("on-update");
                        this.cancel();
                        if (this.success) {
                            console.log(this.success);
                            this.success();
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>

<style>
</style>